import { Carousel } from 'react-bootstrap';
import kingdomwar from '../images/webp/kingdomwar.webp';
import raidboss from '../images/webp/raidboss.webp';
import newbieguide from '../images/webp/newbie-guide.webp';
import { LinkContainer } from 'react-router-bootstrap';
import { useLayout } from '../Context/LayoutProvider';

function Banner() {
    const { hideBanner } = useLayout();
    if (hideBanner) return null;
    return (
        <div className="banner-wrapper mobile-hidden">
            <Carousel fade touch={false} keyboard={false} controls={true} indicators={true} interval={6000}>
                <Carousel.Item>
                    <LinkContainer exact to="/guide/newbies/NewbieGuide">
                        <div className="carousel-slide-container">
                            <img
                                className="carousel-slide-img d-block w-100"
                                src={newbieguide}
                                alt="Newbie Guide slide"
                            />
                            <div className="carousel-slide-overlay" />
                        </div>
                    </LinkContainer>
                    <Carousel.Caption className="carousel-slide-caption">
                        <h3 className="carousel-slide-title">Newbie Quest</h3>
                        <p className="carousel-slide-subtitle">Complete this quest to get started on your adventure!</p>
                        <span className="carousel-cta-btn">View Guide</span>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <div className="carousel-slide-container">
                        <img
                            className="carousel-slide-img d-block w-100"
                            src={kingdomwar}
                            alt="Kingdom War slide"
                        />
                        <div className="carousel-slide-overlay" />
                    </div>
                    <Carousel.Caption className="carousel-slide-caption">
                        <h3 className="carousel-slide-title">Kingdom War</h3>
                        <p className="carousel-slide-subtitle">Fight to win glory for your Guild!</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <div className="carousel-slide-container">
                        <img
                            className="carousel-slide-img d-block w-100"
                            src={raidboss}
                            alt="Raid boss slide"
                        />
                        <div className="carousel-slide-overlay" />
                    </div>
                    <Carousel.Caption className="carousel-slide-caption">
                        <h3 className="carousel-slide-title">Raid Bosses</h3>
                        <p className="carousel-slide-subtitle">Defeat Raid Bosses for grand rewards.</p>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        </div>
    );
}

export { Banner };
